import {
  selectFiltersConfig as selectFiltersConfigLir,
  filtersConfig as filtersConfigLir,
  checkboxConfig as checkboxConfigLir,
} from "../../lir/helper";
import {
  selectFiltersConfig as selectFiltersConfigEvents,
  filtersConfig as filtersConfigEvents,
  checkboxConfig as checkboxConfigEvents,
} from "../../events/helper";
import {
  selectFiltersConfig as selectFiltersConfigLocations,
  filtersConfig as filtersConfigLocations,
  checkboxConfig as checkboxConfigLocations,
} from "../../locations/columns";
import {
  selectFiltersConfig as selectFiltersConfigStakeholders,
  filtersConfig as filtersConfigStakeholders,
  checkboxConfig as checkboxConfigStakeholders,
} from "../../stakeholder/helper";
import { getLirFilterOptions, mapLirs } from "../../lir/helper";
import { getLocationFilterOptions } from "../../locations/helper";
import { allStatuses, mapLocations } from "../../locations/helper";
import { getEventFilterOptions, mapEvents } from "../../events/helper";
import { getStakeholderFilterOptions, mapStakeholders } from "../../stakeholder/helper";

export const defaultSelectOptions = {
  locations: {
    status: allStatuses,
    country: [],
    type: []
  },
  lir: {
    country: [],
    category: [],
  }
};

export const getConfig = (state) => {
  switch (state) {
    case 'lir':
      return {
        filtersConfig: filtersConfigLir,
        checkboxConfig: checkboxConfigLir,
        selectFiltersConfig: selectFiltersConfigLir,
      }
    case 'events':
      return {
        filtersConfig: filtersConfigEvents,
        checkboxConfig: checkboxConfigEvents,
        selectFiltersConfig: selectFiltersConfigEvents,
      }
    case 'locations':
      return {
        filtersConfig: filtersConfigLocations,
        checkboxConfig: checkboxConfigLocations,
        selectFiltersConfig: selectFiltersConfigLocations,
      }
    case 'stakeholders':
      return {
        filtersConfig: filtersConfigStakeholders,
        checkboxConfig: checkboxConfigStakeholders,
        selectFiltersConfig: selectFiltersConfigStakeholders,
      }
    case 'administrativeLevel1':
    case 'administrativeLevel2':
    case 'administrativeLevel3':
    case 'administrativeLevel4':
    case 'administrativeLevel5':
    default:
      return {
        filtersConfig: {
          name: '',
        },
        selectFiltersConfig: {
          country: {
            type: 'select',
            label: 'Country',
            placeholder: (t) => `${t('Filter by')} ${t('country')}`,
            style: { flex: 1 },
            labelStyle: { flex: 1 },
            getLabel: (option) => option.label,
            getValue: (option) => option.value,
          },
        },
        checkboxConfig: {
          name: 'Name',
        },
      }
  }
}

export const selectMaper = {
  locations: (prev, data) => ({
    ...prev,
    ...getLocationFilterOptions(data.options, 'locations'),
  }),
  stakeholders: (prev, data) => ({
    ...prev,
    ...getStakeholderFilterOptions(data.options),
  }),
  events: (prev, data) => ({
    ...prev,
    ...getEventFilterOptions(data.options),
  }),
  lir: (prev, data) => ({
    ...prev,
    ...getLirFilterOptions(data.options),
  }),
  administrativeLevel1: (prev, data) => ({
    ...prev,
    ...getLirFilterOptions(data.options),
  }),
  administrativeLevel2: (prev, data) => ({
    ...prev,
    ...getLirFilterOptions(data.options),
  }),
  administrativeLevel3: (prev, data) => ({
    ...prev,
    ...getLirFilterOptions(data.options),
  }),
  administrativeLevel4: (prev, data) => ({
    ...prev,
    ...getLirFilterOptions(data.options),
  }),
  administrativeLevel5: (prev, data) => ({
    ...prev,
    ...getLirFilterOptions(data.options),
  }),
}

export const dataMaper = {
  lir: (data) => mapLirs(data.data, data.options, 0),
  events: (data) => mapEvents(data.data, data.options, 0),
  locations: (data) => mapLocations(data.data, data.options, 0),
  stakeholders: (data) => mapStakeholders(data.data, data.options, 0),
};

const defaultActiveFilters = { page: 1, pageSize: 20 };

export const getFilters = (params, key = 'published', state) => {
  try {
    if (params.get('activeTab') !== state) {
      throw new Error('Not same tab');
    }

    if (params.has(key)) {
      const parsed = JSON.parse(params.get(key));
      if (typeof parsed.page === 'number') {
        return parsed;
      }
      return { ...parsed, ...defaultActiveFilters };
    }

    return defaultActiveFilters;
  } catch (err) {
    return defaultActiveFilters;
  }
}
